import styled from 'styled-components';
import { Chip, Typography } from '@material-ui/core';

export const CardContainer = styled.div`
	text-align: center;
	position: relative;

	box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.04);
	border: solid 0.3px #b4b3b369;
	background-color: #ffffff;
	.MuiTypography-paragraph {
		${props => props.theme.breakpoints.up('xs')} {
			margin-bottom: 22px;
		}
		${props => props.theme.breakpoints.up('sm')} {
			margin-bottom: 26px;
		}
	}

	${props => props.theme.breakpoints.up('xs')} {
		/* width: 100%; */
		margin: 0px 0px 20px 0px;

		.card_title {
			font-size: 22px;
			line-height: 28px;
			font-weight: 300;
		}

		.info-primary {
			font-size: 13px;
			line-height: 16px;
			color: #515151;
			font-weight: 400;
		}

		.info-secondary {
			font-size: 11px;
			line-height: 14px;
			color: #515151;
		}
	}
	${props => props.theme.breakpoints.up('sm')} {
		margin: 10px 15px 25px 15px;

		.card_title {
			font-size: 23px;
			line-height: 32px;
		}

		.info-primary {
			font-size: 18px;
			line-height: 22px;
			min-height: 66px;
		}

		.info-secondary {
			font-size: 14px;
			line-height: 17px;
			margin-bottom: 70px;
		}

		.MuiButton-root {
			position: relative;
			/* left: 28%; */
			bottom: 0px;
		}
	}
`;

export const TagContainer = styled.div`
	display: flex;
	justify-content: center;
	padding-bottom: 16px;
`;

export const StyledTag = styled(Chip)`
	&.MuiChip-root {
		background-color: ${props => props.tagColor};
		color: ${props => props.color};
	}
`;

export const ImageContainer = styled.div`
	background-image: url(${props => props.image});
	height: 150px;
	width: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	flex-direction: column;
	display: flex;
	justify-content: center;
	align-items: center;

	${props => props.theme.breakpoints.up('xs') && props.image} {
		height: 120px;
	}

	${props => props.theme.breakpoints.up('sm')} {
		height: 150px;
	}
`;

export const DescriptionContainer = styled.div`
	padding: 15px 29px 29px 29px;
`;

export const TitleContainer = styled.div`
	${props => props.theme.breakpoints.up('xs')} {
		padding: 8px 0px;
	}

	${props => props.theme.breakpoints.up('sm')} {
		min-height: 65px;
	}
`;

export const CardTitle = styled(Typography)`
	${props => props.theme.breakpoints.up('xs')} {
		&.MuiTypography-root {
			font-size: 22px;
			line-height: 28px;
			font-weight: 300;
		}
	}

	${props => props.theme.breakpoints.up('sm')} {
		&.MuiTypography-root {
			font-size: 23px;
			line-height: 32px;
		}
	}
`;

export const ImageOffContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	position: relative;
	width: 98%;
`;

export const ImageOff = styled.img`
	position: absolute;
	top: 10px;
	width: 20%;
	height: auto;
`;

export const DiscountContainer = styled.div``;

export const DiscountText = styled(Typography)`
	${props => props.theme.breakpoints.up('xs')} {
		&.MuiTypography-root {
			font-size: 13px;
			line-height: 28px;
			font-weight: 600;
			text-align: left;
			margin: 12px 0px;
			color: grey;
		}
	}

	${props => props.theme.breakpoints.up('sm')} {
		&.MuiTypography-root {
			font-size: 15px;
			line-height: 20px;
			text-align: left;
		}
	}
`;
